import { WarehouseIncomeItemValues } from '../WarehouseIncomesPage/services';

export const MAX_COMMENT_LENGTH = 500;
export const ITEM_NAME_CELL_WIDTH = 320;

export const INCOME_ITEM_COLUMNS = [
  { key: 'name', label: 'Название' },
  { key: 'quantity', label: 'Кол-во' },
  { key: 'purchasePrice', label: 'Цена за ед.' },
  { key: 'totalPrice', label: 'Цена' },
  { key: 'batchNumber', label: 'Партия' },
  { key: 'comment', label: 'Комментарий' },
] as const;

export const EMPTY_ITEM: WarehouseIncomeItemValues = {
  nomenclatureId: null,
  nomenclatureName: '',
  nomenclatureUnitOfMeasurement: undefined,
  quantity: null,
  purchasePrice: null,
  batchNumber: '',
  comment: '',
};

export const TABLE_STYLES = {
  tableLayout: 'auto',
  '& .MuiTableCell-root': {
    whiteSpace: 'nowrap',
    minHeight: '3rem',
  },
  '& .MuiTableCell-root.name-cell': {
    width: '30%',
  },
  '& .MuiTableCell-root.number-cell': {
    width: '20%',
  },
  '& .MuiTableCell-root.text-cell': {
    width: '20%',
  },
};
